import { translate } from 'translations';
import styles from './emptySkillTree.module.scss';

const EmptySkillTree = () => {
    return (
        <div className={styles['empty-skill-tree']}>
            <img
                className={styles['background-image']}
                src={`${process.env.PUBLIC_URL}/images/emptySkillTree.svg`}
                alt="noSkillTree"
                key="noSkillTree"
            ></img>
            <div className={styles.top}>
                <div className={styles['top-left']}>
                    <span className={styles['left-title']}>{translate('skillTree')}&nbsp;</span>
                    <span className={styles['left-number']}>(0)</span>
                </div>
            </div>
            <img
                src={`${process.env.PUBLIC_URL}/images/locked.svg`}
                alt="lockedCard"
                key="lockedCard"
                className={styles['locked-image']}
            />
            <div className={styles.title}>{translate('EmptySkillTreeTitle')}</div>
            <div className={styles.message}>{translate('EmptySkillTreeMessage')}</div>
            <div className={styles.contact}>{translate('ToJoinItContactYourCSM')}</div>
        </div>
    );
};

export default EmptySkillTree;
